<div class="p-6 max-w-5xl mx-auto">
  <h1 class="sr-only">Past support emails</h1>

  <a
    routerLink="/support-email"
    class="inline-block text-sm text-blue-600 no-underline hover:underline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 mb-4"
    >← Reply settings</a
  >

  <p class="text-sm text-slate-700 max-w-2xl mb-6">
    Draft replies for emails that came in on an earlier day, as if they had just arrived. Tick the emails to draft;
    ones that already got a draft can't be picked. Nothing is sent: the drafts wait in Zoho for a person.
  </p>

  <div class="mb-6">
    <label for="past-emails-day" class="block text-sm font-medium text-slate-700 mb-1">Day (New York time)</label>
    <p-datepicker
      inputId="past-emails-day"
      [ngModel]="day()"
      (ngModelChange)="day.set($event)"
      dateFormat="dd-mm-yy"
      [maxDate]="today"
      [showIcon]="true"
    />
  </div>

  @if (list.isLoading()) {
    <p class="text-sm text-muted-color">Loading emails…</p>
  } @else if (list.error()) {
    <div class="flex items-center gap-3">
      <p class="text-sm text-muted-color">The emails for this day could not be loaded.</p>
      <p-button label="Try again" severity="secondary" size="small" (onClick)="list.reload()" />
    </div>
  } @else if (emails(); as emails) {
    @let dayLabel = day() | date: dateFormat;
    <div class="flex flex-wrap items-center justify-between gap-3 mb-3">
      <p class="text-sm text-slate-700" aria-live="polite">
        {{ emailCount(emails.length) }} on {{ dayLabel }}.
        @if (draftedCount() > 0) {
          {{ draftedCount() }} already drafted.
        }
      </p>
      @let count = selected().length;
      <homey-submit-button
        [label]="'Draft replies for ' + emailCount(count)"
        [submitFunction]="draft"
        [disabled]="count === 0"
      />
    </div>

    <p-table
      class="block"
      size="small"
      dataKey="messageId"
      [value]="emails"
      [selection]="selected()"
      (selectionChange)="selected.set($event)"
      [rowSelectable]="isSelectable"
    >
      <ng-template pTemplate="caption">
        <span class="sr-only">Emails on {{ dayLabel }}</span>
      </ng-template>
      <ng-template pTemplate="header">
        <tr class="[&>th]:whitespace-nowrap">
          <th class="w-12"><p-tableHeaderCheckbox ariaLabel="Select every email without a draft" [disabled]="noneSelectable()" /></th>
          <th>Received</th>
          <th>From</th>
          <th>Subject</th>
          <th><span class="sr-only">Status</span></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-email [homeyTypedTableRow]="emails">
        @let selectable = isSelectable({data: email});
        <tr [class.text-muted-color]="!selectable">
          <td>
            <p-tableCheckbox [value]="email" [disabled]="!selectable" [ariaLabel]="'Select ' + (email.subject || 'email')" />
          </td>
          <td class="whitespace-nowrap">{{ receivedTime(email) }}</td>
          <td class="max-w-56 truncate" [title]="email.from ?? ''">{{ email.from ?? '-' }}</td>
          <td class="max-w-md truncate" [title]="email.subject ?? ''">{{ email.subject || '(no subject)' }}</td>
          <td class="whitespace-nowrap">
            @if (email.drafted) {
              <p-tag severity="secondary" class="!py-0">Drafted</p-tag>
            } @else if (queued().has(email.messageId)) {
              <p-tag severity="info" class="!py-0">Queued</p-tag>
            }
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="5" class="text-center">No emails came in on this day.</td>
        </tr>
      </ng-template>
    </p-table>
  }
</div>
